import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer: React.FC = () => {
    return (
        <Box
            component="footer"
            sx={{
                backgroundColor: '#88A9C3',
                color: 'black',
                textAlign: 'center',
                padding: '10px 0',
                // position: 'fixed',
                bottom: 0,
                width: '100dvw',
                marginTop: '5dvh'
                // zIndex: 1000,
            }}
        >
            <Typography variant="body2">
                &copy; {new Date().getFullYear()} Parallax Self. Todos os direitos reservados.
            </Typography>
        </Box>
    );
};

export default Footer;